function NotFound() {
	return <div>Страница не найдена</div>;
}

export default NotFound;
